import Tool, { type ToolArgs } from '../../../tools/Tool';
import { Transforms } from 'slate';
import TableUtils from '../TableUtils';
import { svgToIcon } from '../../../components/Toolbar/toolbarUtils';
import alternateRowsSvg from '../../../assets/icons/alternateRows.svg';

class ToolAlternateRowToggle extends Tool {
  static toolName = 'Alternate row color';

  static action({ editor }: ToolArgs): void {
    if (!editor.selection) return;

    const tableEntry = TableUtils.currentTable(editor);
    if (!tableEntry) return;

    if (tableEntry[0].table_alternateRows) {
      Transforms.unsetNodes(
        editor,
        ['table_alternateRows', 'table_alternateRowColor'],
        {
          at: tableEntry[1],
        }
      );
    } else {
      Transforms.setNodes(
        editor,
        { table_alternateRows: true },
        {
          at: tableEntry[1],
        }
      );
    }
  }

  static isActive({ editor }: ToolArgs): boolean {
    if (!editor?.selection) return false;

    const tableElement = TableUtils.currentTableElement(editor);
    if (!tableElement) return false;

    return Boolean(tableElement.table_alternateRows);
  }

  static isEnabled({ editor }: ToolArgs): boolean {
    if (!editor?.selection) return false;

    const tableElement = TableUtils.currentTableElement(editor);
    if (!tableElement) return false;

    return true;
  }

  static renderMenuIcon() {
    return svgToIcon(alternateRowsSvg, { className: 'fa-fw' });
  }
}

export default ToolAlternateRowToggle;
